import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { FeatureFlagRecord } from "../FeatureFlagRecord";

export function getQueryKey() {
  return ["deletedFeatureFlagRecords"];
}

export function useDeletedFeatureFlags(enabled: boolean = true) {
  const { featureFlagService } = useDomainServices();

  return useQuery<FeatureFlagRecord[], Error>({
    queryKey: getQueryKey(),
    queryFn({ signal }) {
      return featureFlagService.getAllDeleted({ abortSignal: signal });
    },
    enabled,
  });
}
